<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import ViewerCountWidget from '@/widgets/ViewerCountWidget';

function fakeViewerCount() {
	return Math.floor(Math.random() * 900) + 50;
}

const mockApi = {
	get(path) {
		if(path.includes('/settings/')) return Promise.resolve({});
		if(path.includes('/channels') && path.includes('/info')) return Promise.resolve({ numViewers: fakeViewerCount(), numLive: 1 });
		if(path.includes('/channels')) return Promise.resolve([]);
		return Promise.resolve({});
	},
	post() { return Promise.resolve(); },
};
const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };

export default {
	name: 'ViewerCountWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._stopUpdates();
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			this.widget = new ViewerCountWidget({
				container: this.$refs.container,
				api: mockApi,
				socket: mockSocket,
				hash: 'preview',
			});
			await this.widget.init();

			// Load real channels for icons, deduplicated by service
			try {
				const channels = await this.$api.get('channels/widgets');
				this.widget._updateChannels(channels);
			} catch(e) {
				// ignore, preview will show empty
			}

			this._applySettings(this.settings);
			this._startUpdates();
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
		_startUpdates() {
			this._updateIntervalId = setInterval(() => {
				if(!this.widget) return;
				for(const chat of this.widget.chats) {
					if(chat.info) chat.info.numViewers = fakeViewerCount();
				}
				this.widget.render();
			}, 2000);
		},
		_stopUpdates() {
			if(this._updateIntervalId) {
				clearInterval(this._updateIntervalId);
				this._updateIntervalId = null;
			}
		},
	},
};
</script>
